module.exports = __webpack_public_path__ + "static/media/BouyantKettle.617b1359.mp3";